<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-card-text>
      <v-container grid-list-md style="min-width: 100%" class="py-0">
        <v-layout wrap>
          <v-flex md12 v-if="this.funcionario.item != null">
            <strong>Nro de item :</strong> {{ this.funcionario.item }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.unidad != null">
            <strong>Nombre padre:</strong> {{ this.funcionario.padres_unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.unidad != null">
            <strong>Nombre unidad:</strong> {{ this.funcionario.unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.cargo != null">
            <strong>Cargo:</strong> {{ this.funcionario.cargo }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.puesto != null">
            <strong>Puesto:</strong> {{ this.funcionario.puesto }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.sueldo != null">
            <strong>Sueldo:</strong> {{ this.funcionario.sueldo }}
          </v-flex>
        </v-layout>
        <v-layout wrap row v-if="this.funcionario.item != 0">
          <v-flex>
            <v-radio-group
              v-model="con_sin_sueldo"
              row
              :rules="[
                v => {
                  if (v == null) return 'El campo es obligatorio.';
                  return true;
                }
              ]"
            >
              <v-flex xs12>
                <v-radio label="Con sueldo" :value="1"></v-radio>
              </v-flex>
              <v-flex xs12>
                <v-radio label="Sin sueldo" :value="2"></v-radio>
              </v-flex>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout wrap row v-if="this.funcionario.item != 0">
          <v-flex xs12 md4>
            <v-text-field
              type="date"
              label="Fecha desde"
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              @change="alertarAprobacion()"
              @input="
                obtenerItemsDisponibles() &&
                  esFeriadoOFinDeSemana(form.fecha_desde, 1)
              "
            />
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              type="date"
              label="Fecha de conclusión"
              v-model="form.fecha_hasta"
              @input="
                obtenerItemsDisponibles() &&
                  esFeriadoOFinDeSemana(form.fecha_hasta, 2)
              "
              :rules="$validate(['required'])"
              required
            />
          </v-flex>

          <v-flex
            xs12
            md4
            v-if="
              this.form.id_estado != 1 &&
                this.form.id_estado != 64 &&
                this.form.id_estado != 53
            "
          >
            <v-autocomplete
              :items="itemsDisponibles"
              item-text="nro_item"
              item-value="nro_item"
              :rules="$validate(['required'])"
              required
              label="ITEM"
              :loading="loading"
              @change="cargarDatos()"
              v-model="form.nro_item"
            />
          </v-flex>

          <v-flex xs12 md6 v-if="!data.id && this.funcionario.item != 0">
            <!-- para nuevo interinato-->
            <v-autocomplete
              v-if="
                this.form.id_estado != 1 &&
                  this.form.id_estado != 64 &&
                  this.form.id_estado != 53
              "
              :items="unidades"
              item-text="nombre_unidad"
              :item-value="val => parseInt(val.id)"
              label="Unidad"
              v-model="form.id_unidad"
              :rules="$validate(['required'])"
              required
              disabled
              @change="obtenerOrganigrama"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 md6 v-if="data.id">
            <!-- para editar interinato-->
            <v-autocomplete
              v-if="
                this.form.id_estado != 1 &&
                  this.form.id_estado != 64 &&
                  this.form.id_estado != 53
              "
              :items="unidades"
              item-text="nombre_unidad"
              :item-value="val => parseInt(val.id)"
              label="Unidad"
              v-model="form.id_unidad"
              :rules="$validate(['required'])"
              required
              disabled
            >
            </v-autocomplete>
          </v-flex>

          <v-flex xs12 md6>
            <v-autocomplete
              v-if="
                this.form.id_estado != 1 &&
                  this.form.id_estado != 64 &&
                  this.form.id_estado != 53
              "
              :items="lista_puestos"
              item-text="denominacion"
              :item-value="val => parseInt(val.id_puesto)"
              label="Puesto"
              v-model="form.id_puesto"
              :rules="$validate(['required'])"
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              v-model="form.id_cargo"
              :items="lista_cargos"
              item-text="denominacion"
              :item-value="val => parseInt(val.id)"
              label="Seleccione Cargo"
              disabled
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios</small
      >
      <v-spacer></v-spacer>
      <v-btn @click.native="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :loading="loading"
        :disabled="!valid"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: [
    "id_tipo_justificacion",
    "funcionario",
    "unidades",
    "cargos",
    "puestos",
    "data"
  ],
  data() {
    return {
      valid: false,
      loading: false,
      form: this.data,
      itemsDisponibles: [],
      treeOrganizacion: [],
      obtenerOrganigrama: [],
      nro_item: null,
      id_puesto: null,
      tree: [],
      bandera_fecha: false,
      bandera_fecha2: false,
      fecha_futuro: false,
      con_sin_sueldo: null,
      lista_puestos: [],
      lista_cargos: [],
      item_edicion: {}
    };
  },
  async mounted() {
    await this.fijarDatosFuncionario();
    await this.obtenerItemsDisponibles();
    await this.obtenerPuestos();
    await this.obtenerCargos();
    if (this.data.id) {
      await this.cargarDatosInterinato();
      this.form.nro_item = parseInt(this.form.nro_item);
      this.form.id_puesto = parseInt(this.form.id_puesto);
      this.form.id_cargo = parseInt(this.form.id_cargo);
    }
    this.$message.info(
      "Ingrese primero la fecha desde y conclusión para luego seleccionar el item"
    );
  },
  methods: {
    async cargarDatosInterinato() {
      try {
        let nro_item = null;
        let id_unidad = null;
        let id_puesto = null;
        let id_cargo = null;
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "SELECT * FROM movilidad.v_interinatos where id_movilidad=(${parseInt(
                  this.data.id
                )})"){
                  respuesta
                }
              }
            `
        });
        if (respuesta.runQuery.respuesta) {
          nro_item = respuesta.runQuery.respuesta[0].nro_item;
          id_unidad = respuesta.runQuery.respuesta[0].id_unidad;
          id_puesto = respuesta.runQuery.respuesta[0].id_puesto + "";
          id_cargo = respuesta.runQuery.respuesta[0].id_cargo + "";
        }
        this.form.nro_item = nro_item;
        this.form.id_unidad = id_unidad;
        this.form.id_puesto = id_puesto;
        this.form.id_cargo = id_cargo;
        this.item_edicion = {
          nro_item: parseInt(this.form.nro_item),
          id_puesto: parseInt(this.form.id_puesto),
          id_cargo: parseInt(this.form.id_cargo),
          id_unidad: parseInt(this.form.id_unidad)
        };
        this.itemsDisponibles.push(this.item_edicion);
      } catch (error) {
        console.log(error);
      }
    },
    alertarAprobacion() {
      // Estado programado
      if (this.form.id_estado == 64) {
        if (
          this.$moment() >= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono la fecha actual o una fecha pasada, por lo tanto la movilidad se aprobara si la guarda"
          );
        }
      }
      // Estado Alta o alta temporal
      if (this.form.id_estado == 1 || this.form.id_estado == 53) {
        if (
          this.$moment() <= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono una fecha a futuro, por lo cual no puede guardar la movilidad, ya que fue aprobada"
          );
          this.fecha_futuro = true;
        } else {
          this.fecha_futuro = false;
        }
      }
    },
    async obtenerPuestos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
            runQuery(consulta:"select * FROM movilidad.v_puestos_jerarquicos"){
            respuesta
            }
            } 

 `
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_puestos = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerCargos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
            runQuery(consulta:"select * FROM movilidad.cargo"){
            respuesta
            }
            } 
 `
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_cargos = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    obtenerIdItem(nro) {
      try {
        const id_item = this.itemsDisponibles.find(
          fruta => fruta.nro_item == nro
        ).id;
        return id_item;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarDatos() {
      const elemento = this.itemsDisponibles.find(
        item => parseInt(item.nro_item) == this.form.nro_item
      );
      console.log(
        "🚀 ~ file: ComisionInterinato.vue:355 ~ cargarDatos ~ elemento:",
        elemento
      );
      if (!this.data.id) {
        if (elemento) {
          this.form.id_unidad = elemento.id_unidad;
          this.form.id_cargo = elemento.id_cargo;
          this.form.id_puesto = elemento.id_puesto;

          this.form.sueldo = elemento.sueldo;
          this.form.padres_unidad = elemento.padres_unidad;
          this.form.nro_item = elemento.nro_item;
        }
      } else {
        if (elemento) {
          this.form.id_unidad = elemento.id_unidad;
          this.form.id_puesto = elemento.id_puesto;
          this.form.id_cargo = elemento.id_cargo;
          this.form.sueldo = elemento.sueldo;
        }
      }
    },
    async obtenerItemsDisponibles() {
      if (
        this.form.id_estado != 1 &&
        this.form.id_estado != 64 &&
        this.form.id_estado != 53
      ) {
        try {
          this.itemsDisponibles = [];
          this.form.id_unidad = null;
          this.form.id_cargo = null;
          this.form.id_puesto = null;
          this.form.sueldo = null;
          this.form.padres_unidad = null;
          this.id_item = null;
          this.form.nro_item = null;
          if (
            this.form.fecha_desde &&
            this.form.fecha_hasta &&
            this.form.fecha_desde != "" &&
            this.form.fecha_hasta != ""
          ) {
            this.loading = true;
            let res = await this.$service.graphql({
              query: `
                  query{
                  runQuery(consulta: "SELECT * FROM movilidad.fn_item_acefalo_interinato('${this.form.fecha_desde}','${this.form.fecha_hasta}') AS (id int,nro_item int,unidad varchar,id_unidad int,id_cargo int,cargo varchar,libre int,sueldo varchar,id_puesto int,padres_unidad varchar,fecha_desde date, fecha_hasta date)"){
                  respuesta
                  }
                  }
                  `
            });
            this.itemsDisponibles = res.runQuery.respuesta;
            if (this.data.id && this.item_edicion.nro_item) {
              // ADICIONAMOS EL ITEM ASIGNADO AL MOMENTO DE EDITAR
              this.itemsDisponibles.push(this.item_edicion);
            }
            this.loading = false;
            this.cargarDatos();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async esFeriadoOFinDeSemana(fecha, valor) {},
    async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        } else {
          this.bandera_fecha2 = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ", fecha);
          this.bandera_fecha = true;
          return true;
        }
        if (!fecha && valor == 2) {
          this.$message.info("Sin fecha hasta");
          this.bandera_fecha2 = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
                  query{
                  runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                  }
                  }
                  `
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(
                `La fecha ${this.$moment(fecha).format(
                  "DD/MM/YYYY"
                )} cae en fin de semana o feriado`
              );
              this.bandera_fecha = true;
              return true;
            }
            if (respuesta == 1 && valor == 2) {
              this.$message.info(
                `La fecha ${this.$moment(fecha).format(
                  "DD/MM/YYYY"
                )} cae en fin de semana o feriado`
              );
              this.bandera_fecha2 = true;
              return true;
            }
            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (this.form.editar) {
        try {
          let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
            this.form.fecha_desde,
            1
          );
          let validacion_fecha2 = await this.esFeriadoOFinDeSemanaVerificar(
            this.form.fecha_hasta,
            1
          );
          if (validacion_fecha || validacion_fecha2) {
            return;
          }
          if (this.$refs.form.validate()) {
            this.loading = true;
            let id_puesto = this.form.id_puesto;
            let id_cargo = this.form.id_cargo;
            let id_tipo_justificacion = this.id_tipo_justificacion;
            let user = this.$storage.get("user");
            let res = await this.$service.graphql({
              query: `
                  query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.form.nro_item}, ${id_tipo_justificacion},'${this.form.fecha_hasta}',${this.form.id_estado})"){
                  respuesta
                  }
                  }
                  `
            });
            res =
              res.runQuery.respuesta[0].fn_modifica_movilidad_interinato_estado;

            let resps = res.split("|");
            let correcto = resps[0];

            if (correcto === "1") {
              this.$message.success("Actualización exitosa");
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          if (this.$refs.form.validate()) {
            let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
              this.form.fecha_desde,
              1
            );
            let validacion_fecha2 = await this.esFeriadoOFinDeSemanaVerificar(
              this.form.fecha_hasta,
              1
            );
            if (validacion_fecha || validacion_fecha2) {
              return;
            }
            let id_puesto = this.form.id_puesto;
            let id_cargo = this.form.id_cargo;
            let id_tipo_justificacion = this.id_tipo_justificacion;
            let id_item = this.obtenerIdItem(parseInt(this.form.nro_item));
            let user = this.$storage.get("user");
            console.log(`
                query{
                runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_interinato_sin_haber(${this.funcionario.id_persona}, '${this.form.fecha_desde}', '${this.form.fecha_hasta}',${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${id_item},${user.id})"){
                respuesta
                }
                }
                `);
            let res = await this.$service.graphql({
              query: `
                query{
                runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_interinato_sin_haber(${this.funcionario.id_persona}, '${this.form.fecha_desde}', '${this.form.fecha_hasta}',${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${id_item},${user.id})"){
                respuesta
                }
                }
                `
            });
            res =
              res.runQuery.respuesta[0].fn_alta_movilidad_interinato_sin_haber;
            let resps = res.split("|");
            let correcto = resps[0];

            if (correcto === "1") {
              this.$message.success();
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearMovilidad");
    },
    async fijarDatosFuncionario() {
      if (
        this.id_tipo_justificacion === 11 &&
        this.funcionario.id_movilidad != 0
      ) {
        let res = await this.$service
          .graphql({
            query: `
                      query{
                      vMovimientosMovilidad(id:${parseInt(
                        this.funcionario.id_movilidad
                      )}){
                      id
                      id_cargo
                      id_puesto
                      id_unidad
                      id_estado
                      sueldo
                      id_persona
                      nro_item 
                      }
                      }
 `
          })
          .then(async response => {
            if (response) {
              let respuesta = response.vMovimientosMovilidad;
              let movimiento_aux = { ...this.form };
              movimiento_aux.nro_item = parseInt(respuesta.nro_item);
              movimiento_aux.sueldo = respuesta.sueldo;
              movimiento_aux.id_unidad = respuesta.id_unidad;
              movimiento_aux.id_cargo = respuesta.id_cargo;
              movimiento_aux.id_puesto = respuesta.id_puesto;
              this.funcionario.sueldo = response.vMovimientosMovilidad.sueldo;
              this.form = movimiento_aux;
              this.form.nro_item = parseInt(this.form.nro_item);
            }
          });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/ComisionInterinato.vue